export default "__VITE_ASSET__DqbM6BCy__"